import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-ml-auto text-right" }
const _hoisted_2 = { key: 0 }

import { ref, watch } from "vue";
import { ENABLED_FEATURES } from "@/util";
import { sessionApiStore } from "@/hooks";
import { navigateTo, Routes } from "@/router";
import {
  CardPage,
  PasswordInput,
  Typography,
  TextButton,
  EmailInput,
} from "@/components";


/**
 * Displays the login page.
 */
const __default__ = {
  name: "LoginView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const email = ref("");
const password = ref("");
const errorMessage = ref<string | false>("");

/**
 * Navigate to the sign-up page.
 */
function handleSignUp() {
  navigateTo(Routes.CREATE_ACCOUNT);
}

/**
 * Navigate to the forgot password page.
 */
function handleForgotPassword() {
  navigateTo(Routes.FORGOT_PASSWORD);
}

/**
 * Attempts to log the user in.
 */
async function handleSubmit() {
  await sessionApiStore.handleLogin({
    email: email.value,
    password: password.value,
  });
}

watch(
  () => sessionApiStore.loginErrorMessage,
  (message) => (errorMessage.value = message)
);

watch(
  () => [email.value, password.value],
  () => (errorMessage.value = false)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CardPage), { id: "login-view" }, {
    form: _withCtx(() => [
      _createVNode(_unref(EmailInput), {
        modelValue: email.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        "error-message": errorMessage.value,
        onEnter: handleSubmit
      }, null, 8, ["modelValue", "error-message"]),
      _createVNode(_unref(PasswordInput), {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
        onEnter: handleSubmit
      }, null, 8, ["modelValue"])
    ]),
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        color: "primary",
        label: "Login",
        disabled: password.value.length === 0,
        loading: _unref(sessionApiStore).loading,
        class: "login-button",
        "data-cy": "button-login",
        onClick: handleSubmit
      }, null, 8, ["disabled", "loading"]),
      _createElementVNode("div", _hoisted_1, [
        (_unref(ENABLED_FEATURES).SIGN_UP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Typography), { value: "Dont have an account yet?" }),
              _createVNode(_unref(TextButton), {
                text: "",
                small: "",
                label: "Sign Up",
                class: "q-pl-sm",
                color: "primary",
                "data-cy": "button-create-account-redirect",
                onClick: handleSignUp
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(TextButton), {
          text: "",
          small: "",
          label: "Forgot Password",
          color: "primary",
          onClick: handleForgotPassword
        })
      ])
    ]),
    _: 1
  }))
}
}

})